
define('tpl!ui/resource/tpl/tree', ['handlebars'], function(hb){ 
return hb.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  


  return "<div class=\"resource-tree\">\n    <ul></ul>\n</div>\n\n";
  });
});

